import * as _ from 'lodash';
export function flattenSimple<T>(arr: T[]) {
    return _.flatten(arr);
}
